import React, { useEffect, useState } from "react";
import Select from "react-select";
import { fetchJson } from "../../lib/Fetching";

export default function RegistrationUsersDropDown({ value, onChange, company_id }) {
  const [options, setOptions] = useState([]);

  // const handleChange = options => onChange(options.map(o => o.value));
  const handleChange = option => onChange(option ? option.value : null);

  const fetchData = () =>
    fetchJson("/c_r_m/users/registerers.json", { company_id }).then(users => {
      const options = users.map(u => ({ label: u.name, value: u.id }));
      setOptions(options);
    });

  useEffect(() => {
    fetchData();
  }, []);

  if (options.length == 0) return null;

  const selectedValue = options.filter(o => value === o.value);

  return (
    <Select
      value={selectedValue}
      placeholder={"Select Users"}
      isMulti={false}
      autoload={true}
      id="qualifier_id"
      options={options}
      onChange={handleChange}
      isClearable={true}
    />
  );
}
